module.exports = __webpack_public_path__ + "img/edge_activites_paintball.d35d53bf.svg";